<template>
  <div class="flow-record-todo-batch-reject">
    <AsyncTaskModule action-url="/workspace/manager/flow/record/todo/batch/reject"
                     :pre-handle-params="preHandleParams"
                     :extra-params="extraParams"
                     @onClose="handleFinish">
      <template #default="{startTask, executing, complete}">
        <div class="reject-form-content">
          <FlowApprovalForm ref="rejectForm"
                            comment-label="拒绝原因"
                            :comment-required="true"
                            comment-placeholder="请输入拒绝原因"></FlowApprovalForm>
        </div>
        <div class="reject-form-footer">
          <el-button v-if="!complete"
                     size="mini"
                     type="primary"
                     :loading="executing"
                     @click="handleApply(startTask)">{{executing ? '执行中...' : '提交操作'}}</el-button>
          <el-button size="mini"
                     type="default"
                     @click="handleClose">关闭窗口</el-button>
        </div>
      </template>
    </AsyncTaskModule>
  </div>
</template>

<script>
import AsyncTaskModule from '../../../../../elements/AsyncTaskModule'
import FlowApprovalForm from '../../../../../elements/flow/approval/FlowApprovalForm'
export default {
  name: 'FlowRecordTodoBatchReject',
  components: {
    FlowApprovalForm,
    AsyncTaskModule
  },
  props: {
    preHandleParams: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      extraParams: {}
    }
  },
  methods: {
    handleApply (startTask) {
      this.$refs.rejectForm.validate().then(formData => {
        this.$confirm('确定要批量拒绝选中的流程吗？如果流程是办理或委派状态，则会忽略此操作！', '确认提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.extraParams = {
            formData: JSON.stringify(formData)
          }
          this.$nextTick(() => {
            startTask()
          })
        }).catch(() => {})
      }).catch(error => {
        this.$message.warning(error.message)
      })
    },
    handleClose () {
      this.$emit('hidePopover')
    },
    handleFinish () {
      this.$refs.rejectForm.reset()
      this.$emit('hidePopoverAndRefresh')
    }
  }
}
</script>

<style lang="scss">
.flow-record-todo-batch-reject {
  .reject-form-content {
    padding: 15px;
  }
  .reject-form-footer {
    height: 52px;
    background-color: #fff;
    border-top: 1px solid rgba(0,0,0,.05);
    text-align: center;
    line-height: 50px;
  }
}
</style>
